/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Publication connection state.
 */
export enum PropertyPortalPublicationConnectionState {
    CONNECTED = 'connected',
    REFERENCE_ONLY = 'reference_only',
    DISCONNECTED = 'disconnected',
}
